import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import * as AppPropTypes from '../../../lib/PropTypes';

import { useTheme } from '../../../contexts/ThemeContext';
import CardBlock from '../../blocks/Card';
import SportQuestionsList from '../../lists/SportQuestions';
import NhlEnded from '../../partials/NhlEnded';
import ResultsCta from '../../partials/ResultsCta';

import styles from '../../../../styles/themes/nhl/nhl-game-end.module.scss';

import molsonPin from '../../../../img/nhl/mol-beer-pin.png';

const propTypes = {
    game: AppPropTypes.game,
    participation: AppPropTypes.participation,
    className: PropTypes.string,
};

const defaultProps = {
    game: null,
    participation: null,
    className: null,
};

function NhlGameEnd({ game, participation, className }) {
    const { isVariant } = useTheme();
    const intl = useIntl();
    const { points = 0 } = participation || {};
    return (
        <div className={classNames([styles.container, className])}>
            <NhlEnded points={points} />
            <SportQuestionsList
                game={game}
                participation={participation}
                showAnswers
                disabled
                className={styles.questionsList}
            />

            {/* TODO: Send this from backend */}
            {isVariant('allstar') ? (
                <CardBlock
                    image={molsonPin}
                    title={intl.formatMessage({
                        defaultMessage: 'The ultimate All-Star experience awaits',
                        description: 'Card title',
                    })}
                    body={intl.formatMessage({
                        defaultMessage: 'Dive into the arena atmosphere with our partner bars',
                        description: 'Card text',
                    })}
                    label={intl.formatMessage({
                        defaultMessage: 'Where to join us',
                        description: 'Card label',
                    })}
                    url={intl.formatMessage({
                        defaultMessage: '/en/activity-guide',
                        description: 'Card link',
                    })}
                    className={styles.card}
                />
            ) : null}
        </div>
    );
}

NhlGameEnd.propTypes = propTypes;
NhlGameEnd.defaultProps = defaultProps;

export default NhlGameEnd;
